import React from "react";
import Error from "../components/ui/Error/Error";

const ErrorPage = () => {
  return <Error />;
};

export default ErrorPage;
